import { render, staticRenderFns } from "./FormSwitch.vue?vue&type=template&id=4d91cd66&scoped=true&"
import script from "./FormSwitch.vue?vue&type=script&lang=ts&"
export * from "./FormSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./FormSwitch.vue?vue&type=style&index=0&id=4d91cd66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d91cd66",
  null
  
)

export default component.exports